import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

interface FormContainerProps {
  title: string;
  subtitle?: string;
  backTo?: string;
  backText?: string;
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '4xl' | '6xl';
  className?: string;
}

const FormContainer: React.FC<FormContainerProps> = ({
  title,
  subtitle,
  backTo,
  backText = 'Back',
  children,
  maxWidth = '4xl',
  className = ''
}) => {
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md', 
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '4xl': 'max-w-4xl',
    '6xl': 'max-w-6xl'
  };

  return (
    <div className={`container mx-auto px-4 py-8 ${className}`}>
      {/* Back Navigation */}
      {backTo && (
        <div className="mb-6">
          <Link
            to={backTo}
            className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors duration-200"
          >
            <ArrowLeftIcon className="h-4 w-4 mr-2" />
            {backText}
          </Link>
        </div>
      )}

      {/* Main Container */}
      <div className={`${maxWidthClasses[maxWidth]} mx-auto`}>
        <div className="bg-white shadow-sm rounded-lg border border-gray-200">
          {/* Header */}
          <div className="px-6 py-6 border-b border-gray-200">
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {subtitle && (
              <p className="mt-2 text-sm text-gray-600">{subtitle}</p>
            )}
          </div>

          {/* Content */}
          <div className="px-6 py-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormContainer;